// LOGGED IN USER
const getCSAUserAuthData = (state) => state?.user?.csaUserAuthData;
const getJWTAuthToken = (state) => state?.user?.csaUserAuthData?.accessToken;

// ALL USERS
const getEditNameFormStep = (state) => state?.user?.formStep ?? 'confirmEmail';
const getEditNames = (state) => state?.user?.editNames ?? {};

// BOOKING USER
const getBookingId = (state) => state?.user?.bookingId;
const getCruiseName = (state) => state?.user?.cruiseName;
const getPassengerNumber = (state) => state?.user?.passengerNumber;

export {
  getBookingId,
  getCruiseName,
  getCSAUserAuthData,
  getEditNameFormStep,
  getEditNames,
  getJWTAuthToken,
  getPassengerNumber,
};
